import { forwardRef, useContext, useMemo } from "react";
import Dropdown from "@acadia-ui/dropdown";
import { ViewMasterCampaignsContext } from "../../Views/ViewMasterCampaigns";
import _ from "lodash";
import "./AccessPermissions.scss";

const AccessPermissions = (props) => {
	const { permissionedDataKeys } = useContext(ViewMasterCampaignsContext);
	const { permissionedOptions, onChange, type, masterCampaign, ...rest } = props;

	const displayAccessPermissions = useMemo(() => {
		const hasPermissionOptions = Boolean(Object.keys(permissionedDataKeys).length);
		if (type === "master") {
			return hasPermissionOptions;
		}
		if (type === "activation") {
			return Boolean(hasPermissionOptions && masterCampaign.AvailableDataKeyDataValuePermissions?.length);
		}
	}, [type, masterCampaign, permissionedDataKeys]);

	const buildPermissionTypeDropdowns = () => {
		let renderedPermissionedDataKeys = {};
		if (type === "master") {
			renderedPermissionedDataKeys = _.cloneDeep(permissionedDataKeys);
		}
		if (type === "activation") {
			// Only allow permissions that have been selected in the master campaign to be selected in the activation campaign
			const masterCampaignDataValueIDs = masterCampaign.AvailableDataKeyDataValuePermissions.map((dataValue) => {
				return dataValue.DataValueID;
			});
			Object.keys(permissionedDataKeys).forEach((dataKeyName) => {
				const filteredDataKeys = permissionedDataKeys[dataKeyName].filter((dataValue) => {
					return masterCampaignDataValueIDs.includes(dataValue.DataValueID);
				});
				if (filteredDataKeys.length) {
					renderedPermissionedDataKeys[dataKeyName] = filteredDataKeys;
				}
			});
		}
		Object.keys(renderedPermissionedDataKeys).forEach((dataKeyName) => {
			renderedPermissionedDataKeys[dataKeyName] = renderedPermissionedDataKeys[dataKeyName].filter((dataValue) => {
				return !dataValue.IsArchived;
			});
		});
		return Object.keys(renderedPermissionedDataKeys).map((dataKey) => {
			return (
				<Dropdown
					className="permission-type-dropdown"
					value={permissionedOptions[dataKey]}
					options={renderedPermissionedDataKeys[dataKey]}
					multiple={true}
					onChange={(value) => onChange(value, dataKey)}
				>
					{dataKey}
				</Dropdown>
			);
		});
	};

	return (
		<>
			{displayAccessPermissions && (
				<div className="access-permissions-container">
					<div className="access-permissions-title">
						Set access permissions
						<abbr className="required-asterisk" title="Required">
							*
						</abbr>
					</div>
					<div className="permissions-dropdowns">{buildPermissionTypeDropdowns()}</div>
				</div>
			)}
		</>
	);
};

export default AccessPermissions;
